@if (data().schema) {
  <smallstack-form [schema]="data().schema" [options]="{ useInfoBox: data().infoBox }" [(value)]="formData">
    <smallstack-tabbed-form-table [showActions]="false" [showHeader]="false"> </smallstack-tabbed-form-table>
  </smallstack-form>
}
<button [loadingFn]="sendForm()" class="btn btn-primary">{{ data().buttonText }}</button>
